(function() {
  "use strict";

  angular.module("app").directive("cccCommunities", cccCommunities);

  function cccCommunities() {
    return {
      restrict: "EA",
      scope: false,
      controller: "CommunitiesController"
    };
  }
})();
